module.exports = __webpack_public_path__ + "img/adminsEgypt.50f82624.svg";